import { Textarea } from 'braid-design-system';
import type { QuestionProps } from '../../type';
import { EXPERIMENT_TWO_TEXT_MAX_LENGTH } from '../../validation/validationRules';

export const ManagementDetailsQuestion = ({
  value = '',
  message = '',
  tone,
  onChange,
}: QuestionProps) => {
  return (
    <Textarea
      id="managementDetails"
      label="How well does your manager support and guide you and your team?"
      onChange={(event) => onChange(event.currentTarget.value)}
      value={value}
      tone={tone}
      message={message}
      reserveMessageSpace
      characterLimit={EXPERIMENT_TWO_TEXT_MAX_LENGTH}
    />
  );
};
